<template>
  <b-navbar id="template-header" class="p-0 fixed-top d-flex flex-row" toggleable="lg">
    <div class="navbar-button-wrapper d-flex flex-row justify-content-center align-items-center">
      <button
        class="navbar-toggler align-self-center d-none d-lg-block"
        type="button"
        @click="toggleSidebar()"
      >
        <svg-icon size="24" name="menu" class="text-secondarygray"></svg-icon>
      </button>
      <button
        class="navbar-toggler align-self-center d-lg-none"
        type="button"
        @click="toggleMobileSidebar()"
      >
        <svg-icon size="24" name="menu" class="text-secondarygray"></svg-icon>
      </button>
    </div>
    <div class="navbar-brand-wrapper d-flex flex-row justify-content-center align-items-center">
      <router-link to="/">
        <logo-horizontal class="mb-1" />
      </router-link>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-center ml-lg-0">
      <ul class="navbar-nav w-100">
        <li class="nav-item" style="width: 80%">
          <div class="nav-link mt-2 mt-md-0 d-none d-lg-flex search pl-2">
            <box-search v-if="isUserAuthenticated"></box-search>
          </div>
        </li>
      </ul>

      <div class="navbar-nav">
        <div v-if="!isUserAuthenticated" class="align-items-center justify-content-center h-100">
          <router-link :to="{ name: 'SmartOeeLogin' }">
            <b-button variant="success" class="btn-fw">
              {{ $t('register.form.footer.loginLink') }}
            </b-button>
          </router-link>
        </div>
      </div>
      <the-header-profile-dropdown v-if="isUserAuthenticated" />
    </div>
  </b-navbar>
</template>

<script>
import logoHorizontal from '@/assets/images/logo-horizontal.svg';

export default {
  name: 'SmartOeeHeader',
  components: {
    logoHorizontal,
  },
  computed: {
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated;
    },
  },
  methods: {
    toggleSidebar: () => {
      document.querySelector('body').classList.toggle('sidebar-icon-only');
    },
    toggleMobileSidebar: () => {
      document.querySelector('#sidebar').classList.toggle('active');
    },
  },
};
</script>

<style scoped></style>
